import { Thunk } from '../../../generalTypes';
import { selectAllSubFilterOptions } from '../../../state/productMenu/productMenuSelectors';
import { actionSetSubFilterOptions } from '../../../state/productMenu/productMenuActions';
import { FILTERS } from '../../../constants';
import { SubfilterOption } from '../../../state/productMenu/productMenuTypes';
import { selectRangeDataSlice } from '../../../state/rangeData/rangeDataSelectors';
import { ELVARLI_VARIANT } from '../../../components/Sheets/SelectElvarliVariantSheet/SelectElvarliVariantSheet';

export const thunkRemoveUnwantedSectionSubFilterOptions: Thunk =
  () => (dispatch, getState) => {
    const state = getState();
    const selectedElvarliVariant = selectRangeDataSlice(ELVARLI_VARIANT)(state);
    const filterOptions = selectAllSubFilterOptions(state).filter(
      (filterOption: SubfilterOption) =>
        // @ts-ignore LIMITATION OF ANCIENT, PRE-HISTORIC TS-VERSION NOT SUPPORTING TYPE CASTING, SHOULD BE CAST AS STRING,
        // SINCE THIS ALWAYS RUN AFTER ELVARLI VARIANT IS SELECTED.
        filterOption.sectionType === selectedElvarliVariant
    );

    dispatch(actionSetSubFilterOptions(FILTERS.SECTIONS, filterOptions));
  };

export default {
  sceneReady: () => () => {},
};
